<template>
  <v-container
    fluid
    class="pt-8 pl-0 pr-0 pb-0"
  >
    <v-row class="d-flex flex-column flex-sm-row justify-end mb-2 px-4">
      <div
        v-if="showProviderFilter"
        class="mr-sm-3"
      >
        <HiddenProviderToggle
          :checked="showHiddenProviders"
          @change="setShowHiddenProviders"
        />
      </div>

      <MonthPicker
        v-if="useMonthPicker"
        label="Report month"
        :disabled="loading"
        :selectedMonth="selectedMonth.month"
        @select-month="onSelectMonth"
      />
      <DateRangePicker
        v-else
        label="Report date range"
        :disabled="loading"
        :selectedTimeRange="[selectedTimeRange.start, selectedTimeRange.end]"
        @select-range="onSelectRange"
      />
    </v-row>

    <ChairAmountForm
      v-if="showChairAmountForm"
      @change="onChairAmountChange"
    />

    <slot />

    <v-row
      v-if="loading"
      class="text-center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
        style="height: 200px; margin: auto"
      />
    </v-row>
  </v-container>
</template>

<script>
import DateRangePicker from '../DateRangePicker';
import MonthPicker from '../MonthPicker';
import ChairAmountForm from './ChairAmountForm';
import HiddenProviderToggle from './HiddenProviderToggle.vue';

export default {
  name: 'ReportWrapper',
  components: {
    ChairAmountForm,
    DateRangePicker,
    HiddenProviderToggle,
    MonthPicker,
  },
  inject: [
    'getSelectedTimeRange',
    'getSelectedMonth',
    'getActiveTabId',
    'shouldShowHiddenProviders',
    'setTimeRange',
    'setMonth',
    'setShowHiddenProviders',
  ],
  props: [
    'tabLv1Index',
    'tabLv2Index',
    'onLoad',
    'loading',
    'useMonthPicker',
    'showProviderFilter',
    'showChairAmountForm',
  ],
  data() {
    return {
      shouldReload: false, // mark if the child component should reload
    };
  },
  computed: {
    myTabId() {
      return `lv1_${this.tabLv1Index}_lv2_${this.tabLv2Index}`;
    },
    selectedTimeRange() {
      return this.getSelectedTimeRange?.();
    },
    selectedMonth() {
      return this.getSelectedMonth?.();
    },
    showHiddenProviders() {
      return this.shouldShowHiddenProviders?.();
    },
    activeTabId() {
      return this.getActiveTabId?.();
    },
    isActive() {
      return this.myTabId === this.activeTabId;
    },
  },
  methods: {
    loadReport() {
      this.onLoad?.(this.useMonthPicker ? this.selectedMonth : this.selectedTimeRange);
    },
    onSelectRange(payload) {
      const { startDate: start, endDate: end } = payload;
      this.setTimeRange?.({ start, end });
    },
    onSelectMonth(payload) {
      this.setMonth?.({ month: payload });
    },
    onChairAmountChange() {
      this.loadReport();
    },
  },
  watch: {
    // when user selects a new time range/month, inactive tabs should be marked for reloading.
    // when being active again, they reload with newly selected time
    selectedTimeRange(newTime, oldTime) {
      if (newTime.start === oldTime.start && newTime.end === oldTime.end) {
        return;
      }

      if (this.isActive) {
        this.onLoad?.(newTime);
      } else {
        this.shouldReload = true;
      }
    },
    selectedMonth(newVal, oldVal) {
      if (newVal.month === oldVal?.month) {
        return;
      }

      if (this.isActive) {
        this.onLoad?.(newVal);
      } else {
        this.shouldReload = true;
      }
    },
    isActive(active) {
      if (active && this.shouldReload) {
        this.shouldReload = false;
        this.onLoad?.(this.useMonthPicker ? this.selectedMonth : this.selectedTimeRange);
      }
    },
  },
  mounted() {
    this.loadReport();
  },
};
</script>
